import { motion, useReducedMotion } from "framer-motion";
import { Section, Headline, Reveal, Field } from "@/components/primitives";
import { owned } from "@/config";
import { stagger, item, viewport } from "@/lib/motion";

const Line = ({ label, value }) => (
  <div>
    <div className="label mb-1">{label}</div>
    <p className="text-sm leading-relaxed text-cream/80"><Field value={value} /></p>
  </div>
);

export default function Evidence() {
  const reduce = useReducedMotion();
  const L = owned.labels;
  return (
    <Section id="evidence" tone="charcoal">
      <Reveal><Headline>{owned.headline}</Headline></Reveal>
      <motion.div
        variants={reduce ? undefined : stagger(0.1)} initial={reduce ? false : "hidden"} whileInView="show" viewport={viewport}
        className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-2"
      >
        {owned.items.map((it) => (
          <motion.article key={it.title} variants={item} data-testid="evidence-item" className="card rounded-xl p-7">
            <h3 className="font-serif text-2xl text-cream">{it.title}</h3>
            {it.isMap ? (
              <div className="mt-6 space-y-5">
                {it.groups.map((g) => (
                  <div key={g.label}>
                    <div className="label mb-2">{g.label}</div>
                    <div className="flex flex-wrap gap-1.5">{g.items.map((x) => <span key={x} className="chip">{x}</span>)}</div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="mt-6 space-y-5">
                <Line label={L.owned} value={it.owned} />
                <Line label={L.call} value={it.call} />
                <Line label={L.hard} value={it.hard} />
                <Line label={L.result} value={it.result} />
              </div>
            )}
          </motion.article>
        ))}
      </motion.div>
    </Section>
  );
}
